export type AppDateFormats = 'MM/DD/YYYY' | 'DD.MM.YYYY' | 'YYYY-MM-DD' | 'DD/MM/YYYY'
export type AppDateWithTimeFormats = `${AppDateFormats} HH:mm:ss`

export const DEFAULT_SYSTEM_FORMAT_DAY_PICKER = 'YYYY-MM-DD'
export const DEFAULT_SYSTEM_FORMAT_DAY_WITH_TIME = 'YYYY-MM-DD HH:mm:ss'

export const DEFAULT_APP_DATE_FORMAT = 'MM/DD/YYYY'
export const DEFAULT_APP_DATE_WITH_TIME_FORMAT = 'MM/DD/YYYY HH:mm:ss'
export const DEFAULT_APP_TIME_FORMAT = 'HH:mm:ss'
